import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from "vue";
import { useRouter } from "vue-router";
import { useAppStore } from "@/store/AppStore";
import { getTableOfContents } from "@/services/BookService";
import { GetTableOfContentsResponse } from "@/types/responses";
import { Books, H3, Slug } from "@/types/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'LeftBar',
  setup(__props) {

const router = useRouter();
const appStore = useAppStore();

const showMenu = ref(false);
const tableOfContents = ref<Books>({ h0: [] });
const slug = ref<Slug<string>>({});
const vListOpen = ref<string[]>([]); // Binding open
const vListSelected = ref<string[]>([]);

router.beforeEach(async (to) => {
  const pages = ["Book", "Diplomatic Edition", "About Us", "Contact"];
  const currentPageName = to.name as string;

  if (pages.includes(currentPageName)) {
    showMenu.value = true;
  } else {
    showMenu.value = false;
  }

  if (Object.keys(appStore.tableOfContent).length === 0) {
    const response: GetTableOfContentsResponse = await getTableOfContents();

    tableOfContents.value = response.tableOfContents;
    slug.value = response.slug;
    appStore.setTableOfContent(response.tableOfContents);
    appStore.setPageAction(response.pageAction);
    appStore.setSlug(response.slug);
    // console.log(response.tableOfContents);
  }

  if (to.name === "Book") {
    vListOpen.value = [];
    vListSelected.value = [];
    setVListActive(to.params.h0.toString(), to.params.h1.toString(), to.params.h2.toString(), to.params.h3.toString());
  }
});

const setVListActive = (h0: string, h1: string, h2: string, h3: string) => {
  vListOpen.value.push(slug.value[h0]);
  vListOpen.value.push(slug.value[h1]);
  vListOpen.value.push(slug.value[h2]);
  vListSelected.value.push(slug.value[h3]);
};

const genLink = (h0: string, h1: string, h2: string, h3: string, page: string) => {
  return {
    path: `/book/${h0}/${h1}/${h2}/${h3}/${page}`,
  };
};

const getALT = (h3: H3) => {
  return `${h3.pages[0].page} - ${h3.pages[h3.pages.length - 1].page}`;
};

return (_ctx: any,_cache: any) => {
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (showMenu.value)
    ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
        key: 0,
        id: "left-drawer-menu",
        modelValue: _unref(appStore).leftBarDrawer,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(appStore).leftBarDrawer) = $event)),
        clipped: _ctx.$vuetify.display.lgAndUp,
        permanent: _ctx.$vuetify.display.lgAndUp,
        width: 325,
        app: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, {
            density: "compact",
            opened: vListOpen.value,
            "onUpdate:opened": _cache[0] || (_cache[0] = ($event: any) => ((vListOpen).value = $event)),
            selected: vListSelected.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_subheader, null, {
                default: _withCtx(() => [
                  _createTextVNode("Dhammachai Tipitaka")
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableOfContents.value.h0, (h0, h0_index) => {
                return (_openBlock(), _createBlock(_component_v_list_group, {
                  key: h0_index,
                  title: h0.name,
                  value: h0.name,
                  "prepend-icon": "mdi-folder-outline"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_list_item, _mergeProps(props, {
                      title: h0.name
                    }), null, 16, ["title"])
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(h0.h1, (h1, h1_index) => {
                      return (_openBlock(), _createBlock(_component_v_list_group, {
                        key: h1_index,
                        title: h1.name,
                        value: h1.name,
                        "prepend-icon": "mdi-folder-outline"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_list_item, _mergeProps(props, {
                            title: h1.name
                          }), null, 16, ["title"])
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(h1.h2, (h2, h2_index) => {
                            return (_openBlock(), _createBlock(_component_v_list_group, {
                              key: h2_index,
                              title: h2.name,
                              value: h2.name,
                              "prepend-icon": "mdi-folder-outline"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_list_item, _mergeProps(props, {
                                  title: h2.name
                                }), null, 16, ["title"])
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(h2.h3, (h3, h3_index) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: h3_index,
                                    title: h3.name,
                                    value: h3.name,
                                    "prepend-icon": "mdi-file-outline",
                                    to: genLink(h0.slug, h1.slug, h2.slug, h3.slug, String(h3.pages[0].page))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_tooltip, {
                                        activator: "parent",
                                        location: "end"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(getALT(h3)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["title", "value", "to"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["title", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["title", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["title", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["opened", "selected"])
        ]),
        _: 1
      }, 8, ["modelValue", "clipped", "permanent"]))
    : _createCommentVNode("", true)
}
}

})